(function() { window.GUID_5e618976_718c_48ab_ab05_b4549a16fbcf = { getGuid: function() { return "5e618976-718c-48ab-ab05-b4549a16fbcf"; } }; })();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var CS;
(function (CS) {
    var Controls;
    (function (Controls) {
        class ScrollableBarChart {
            get shouldAnimate() {
                return this.numBars < 50;
            }
            get shouldDisplayRank() {
                return (
                // this.statFieldsWithDifferentLegendWhenStacked.indexOf(this.statField) ==
                //   -1 &&
                !this.shouldStack);
            }
            get shouldNotHighlight() {
                return (this.statFieldsThatShouldntBeHighlighted.includes(this.statField) &&
                    this.shouldStack);
            }
            constructor(params) {
                this.id = CS.Helper.generateRandomId();
                this.appElement = null;
                this.containerElement = null;
                this.innerChartElement = null;
                this.innerChartContainerElement = null;
                //private controlsElement: HTMLElement | null = null;
                //private initButtonElement: HTMLElement | null = null;
                //private destroyButtonElement: HTMLElement | null = null;
                this.state = CS.Enumeration.ChartState.Unready;
                this.statField = "";
                this.entityType = "";
                this.datapoints = [];
                this.svg = null;
                this.chartOverlayElement = null;
                this.svgOverlay = null;
                this.svgLegend = null;
                this.xAxisColor = "rgba(255,255,255,0.25)";
                this.barTextColor = "rgba(255,255,255,1)";
                this.rankBarTextColor = "rgba(255,255,255,0.5)";
                this.firstRankBarTextColor = getComputedStyle(document.documentElement)
                    .getPropertyValue("--goldColor")
                    .trim();
                this.secondRankBarTextColor = getComputedStyle(document.documentElement)
                    .getPropertyValue("--silverColor")
                    .trim();
                this.thirdRankBarTextColor = getComputedStyle(document.documentElement)
                    .getPropertyValue("--bronzeColor")
                    .trim();
                this.nameOpacity = 1;
                this.valueOpacity = 0.7;
                this.rankColor = "rgba(255,255,255,1)";
                this.textFontSize = 0;
                this.maxBottomXAxisLabelLength = 25;
                this.chartWidth = 0;
                this.chartHeight = 0;
                this.spacing = 8;
                this._barWidth = 50;
                this.barWidth = this._barWidth;
                this.imageWidth = 0;
                this.marginTop = 0;
                this.marginRight = 0;
                this.symbols = [];
                this.marginBottom = 0;
                this.marginLeft = 0;
                this.numBars = 0;
                this.eventsBound = false;
                this.barFillColor = "#faa41d";
                this.stackedBarFillColor = "#faa41d";
                this.min = 0;
                this.max = 0;
                this.isPercentage = false;
                this.useMinYValueForMin = false;
                this.barPadding = 0.25;
                this.bottomXAxisFontSize = 12;
                this.topXAxisFontSize = 12;
                this.yAxisFontSize = 12;
                this.fontFamily = `"Open Sans", sans-serif`;
                this.legends = [];
                this.sortDirection = CS.Enumeration.SortDirection.Descending;
                this.shouldStack = false;
                this.shouldDisplayAvatar = true;
                this.hideYAxis = false;
                this.statFieldsWithDifferentLegendWhenStacked = [
                    "Score",
                    "EncounterOpponentsScore",
                ];
                this.barOpacity = 1;
                this.mainHighlightedBarOpacity = 1;
                this.secondaryHighlightedBarOpacity = 0.5;
                this.nonHighlightedBarOpacity = 0.2;
                this.anyHighlighted = false;
                this.highlightedBarTextColor = "rgba(255,255,255,1)";
                this.statFieldsThatShouldntBeHighlighted = [
                    "Score",
                    "EncounterOpponentsScore",
                ];
                if (params.id)
                    this.id = params.id;
                if (params.statFieldId)
                    this.statField = params.statFieldId;
                if (params.legends)
                    this.legends = params.legends;
                if (params.valueFormatter)
                    this.valueFormatter = params.valueFormatter;
                if (!this.valueFormatter) {
                    this.valueFormatter = (value) => {
                        const result = value.toString();
                        return result.includes(".") ? result.replace(/\.?0*$/, "") : result;
                    };
                }
                if (this.statField == "WinPercent") {
                    this.valueFormatter = (value) => {
                        let result = value.toString();
                        result = result.includes(".") ? result.replace(/\.?0*$/, "") : result;
                        return `${result}%`;
                    };
                }
                if (params.hideYAxis != null)
                    this.hideYAxis = params.hideYAxis;
                if (this.statField == "Score") {
                    this.datapoints = params.datapoints.map((d) => {
                        const value = Number(d.Value);
                        let valueString = value.toString();
                        const stackedValue = Number(d.StackedValue);
                        let stackedValueString = stackedValue.toString();
                        const xAxisTopLabel = Number(d.XAxisTopLabel);
                        let xAxisTopLabelString = d.XAxisTopLabel;
                        if (value == null || value < 0) {
                            valueString = "0";
                        }
                        if (stackedValue == null || stackedValue < 0) {
                            stackedValueString = "0";
                        }
                        if ((!isNaN && xAxisTopLabel == null) || xAxisTopLabel < 0) {
                            xAxisTopLabelString = "0";
                        }
                        return Object.assign(Object.assign({}, d), { Value: valueString, StackedValue: stackedValueString, XAxisTopLabel: this.valueFormatter(value !== null && value !== void 0 ? value : 0) });
                    });
                }
                else {
                    this.datapoints = params.datapoints.map((d) => {
                        const value = Number(d.Value);
                        return Object.assign(Object.assign({}, d), { XAxisTopLabel: this.valueFormatter(value !== null && value !== void 0 ? value : 0) });
                    });
                }
                this.symbols = this.datapoints.map((d) => d.Id);
                this.anyHighlighted = this.datapoints.some((d) => d.IsHighlightedMain || d.IsHighlightedSecondary);
                this.shouldStack = this.datapoints.some((d) => d.IsStacked);
                if (this.shouldStack) {
                    if (this.statField == "Score") {
                        this.shouldDisplayAvatar = false;
                    }
                }
                this.sortDirection = this.datapoints[0].SortDirection;
                this.baseContainerElementId = params.containerElementId;
                if (params.legendContainerElementId)
                    this.legendContainerElementId = params.legendContainerElementId;
                if (params.barFillColor)
                    this.barFillColor = params.barFillColor;
                if (params.stackedBarFillColor)
                    this.stackedBarFillColor = params.stackedBarFillColor;
                if (params.isPercentage != null)
                    this.isPercentage = params.isPercentage;
                if (params.barTextColorIfStacked)
                    this.barTextColorIfStacked = params.barTextColorIfStacked;
                if (params.stackedBarTextColorIfStacked)
                    this.stackedBarTextColorIfStacked = params.stackedBarTextColorIfStacked;
                if (params.useMinYValueForMin != null)
                    this.useMinYValueForMin = params.useMinYValueForMin;
                if (params.max)
                    this.max = params.max;
                if (params.highlightedBarFillColor)
                    this.highlightedBarFillColor = params.highlightedBarFillColor;
                else
                    this.highlightedBarFillColor = this.barFillColor;
                if (params.highlightedEntityBaseId) {
                    if (this.shouldStack) {
                        this.barFillColor = this.highlightedBarFillColor;
                        this.highlightedEntityBaseIds = undefined;
                    }
                    else {
                        this.highlightedEntityBaseIds = [params.highlightedEntityBaseId];
                        try {
                            const datapoint = this.datapoints.find((d) => this.highlightedEntityBaseIds.indexOf(Number(d.Id)) > -1);
                            if (datapoint == null) {
                                this.barFillColor = this.highlightedBarFillColor;
                                this.highlightedEntityBaseIds = undefined;
                            }
                        }
                        catch (error) {
                            this.barFillColor = this.highlightedBarFillColor;
                            this.highlightedEntityBaseIds = undefined;
                        }
                    }
                }
                if (params.highlightedEntityBaseIds) {
                    if (this.shouldStack) {
                        this.barFillColor = this.highlightedBarFillColor;
                        this.highlightedEntityBaseIds = undefined;
                    }
                    else {
                        if (!this.highlightedEntityBaseIds) {
                            this.highlightedEntityBaseIds = [
                                ...params.highlightedEntityBaseIds,
                            ];
                        }
                        else {
                            this.highlightedEntityBaseIds = [
                                ...this.highlightedEntityBaseIds,
                                ...params.highlightedEntityBaseIds,
                            ];
                        }
                        if (this.highlightedEntityBaseIds) {
                            // remove duplicates
                            this.highlightedEntityBaseIds =
                                this.highlightedEntityBaseIds.filter((v, i, a) => a.indexOf(v) === i);
                            try {
                                const datapoint = this.datapoints.find((d) => this.highlightedEntityBaseIds.indexOf(Number(d.Id)) > -1);
                                if (datapoint == null) {
                                    this.barFillColor = this.highlightedBarFillColor;
                                    this.highlightedEntityBaseIds = undefined;
                                }
                            }
                            catch (error) {
                                this.barFillColor = this.highlightedBarFillColor;
                                this.highlightedEntityBaseIds = undefined;
                            }
                        }
                    }
                }
                if (params.highlightedBarTextColor) {
                    this.highlightedBarTextColor = params.highlightedBarTextColor;
                }
                this.datapoints.forEach((datapoint) => {
                    const isHighlighted = datapoint.IsHighlightedMain || datapoint.IsHighlightedSecondary;
                    if (!isHighlighted && datapoint.IsSpare) {
                        datapoint.OverrideBarColor = "rgba(255,255,255,0.5)";
                    }
                });
                this.xScale = d3.scaleBand().padding(this.barPadding);
                this.yScale = d3.scaleLinear();
                this.setChartDimensions();
                this.rankDatapoints();
            }
            setChartDimensions() {
                return new Promise((resolve, reject) => {
                    try {
                        requestAnimationFrame(() => {
                            if (this.shouldStack) {
                                this.barWidth = this._barWidth * 0.5;
                            }
                            this.imageWidth = this.barWidth;
                            this.marginTop =
                                this.spacing * 4 +
                                    this.imageWidth +
                                    (this.shouldStack && this.shouldDisplayAvatar
                                        ? this.spacing * 2
                                        : 0);
                            this.marginRight = this.spacing;
                            const marginBottom = this.shouldStack && this.statField == "Score"
                                ? Math.min(this.longestBottomXAxisLabelLength * 12, this.maxBottomXAxisLabelLength * 12)
                                : Math.min(this.longestBottomXAxisLabelLength * 6, this.maxBottomXAxisLabelLength * 6);
                            this.marginBottom = this.longestBottomXAxisLabelLength
                                ? // this.longestBottomXAxisLabelLength * 6
                                    marginBottom + this.spacing
                                : this.spacing * 8;
                            this.marginLeft = Math.max(this.firstBottomXAxisLabelLength
                                ? // this.firstBottomXAxisLabelLength * 4
                                    Math.min(this.firstBottomXAxisLabelLength * 4, this.maxBottomXAxisLabelLength * 4)
                                : this.spacing * 6, this.spacing * 6);
                            // this.marginLeft = this.spacing * 6;
                            this.chartHeight = 450;
                            this.chartWidth =
                                this.marginLeft +
                                    this.barWidth * (this.numBars + 1) +
                                    this.marginRight;
                            this.textFontSize = this.barWidth / 4;
                            return resolve();
                        });
                    }
                    catch (error) {
                        console.error("Error while setting chart dimensions", error);
                        return reject();
                    }
                });
            }
            init() {
                return __awaiter(this, void 0, void 0, function* () {
                    yield this.initialize();
                });
            }
            setFallbackHrefs() {
                try {
                    const $containerElement = $(`#scrollable-bar-chart-${this.id}`);
                    if (!$containerElement.length) {
                        throw new Error("App element not found.");
                    }
                    const $images = $containerElement.find(".scrollable-bar-chart__top-x-axis-avatar");
                    if (!$images.length) {
                        return;
                    }
                    $images.each((_, element) => {
                        const $element = $(element);
                        const href = $element.attr("href");
                        const fallbackHref = $element.attr("data-fallback-href");
                        const image = new Image();
                        image.onerror = () => {
                            $element.attr("href", fallbackHref);
                        };
                        if (!CS.Helper.isNullOrWhiteSpace(href)) {
                            image.src = href;
                        }
                    });
                }
                catch (error) {
                    console.error("Error while handling window loaded.", error);
                }
            }
            initialize() {
                return __awaiter(this, void 0, void 0, function* () {
                    try {
                        this.setState(CS.Enumeration.ChartState.Initializing);
                        this.createHTML();
                        yield this.load();
                        this.render()
                            .then(() => {
                            this.bindEvents();
                            this.setState(CS.Enumeration.ChartState.Ready);
                            this.setFallbackHrefs();
                        })
                            .catch((error) => {
                            console.error(error);
                            this.setState(CS.Enumeration.ChartState.Error);
                        });
                    }
                    catch (error) {
                        console.error(error);
                        this.setState(CS.Enumeration.ChartState.Error);
                    }
                    const $containerElement = $(`#scrollable-bar-chart-${this.id}`);
                    $containerElement.offon("click.scrollablebarchartdatapointclick", ".trigger-datapoint-click-event", (e) => {
                        const $datapoint = $(e.currentTarget);
                        const datapoint = $datapoint.attr("data-datapoint");
                        if (datapoint) {
                            this.handleDatapointClick(datapoint);
                        }
                    });
                });
            }
            createHTML() {
                this.appElement = document.body.querySelector(`#${this.baseContainerElementId}`);
                if (this.appElement == null) {
                    throw new Error("Container element not found.");
                }
                const containerHtml = `<div id="scrollable-bar-chart-${this.id}" class="scrollable-bar-chart chart">
      <div id="scrollable-bar-chart-${this.id}-legend" class="scrollable-bar-chart__legend chart__legend"></div>
      </div>`;
                const containerElementExists = document.body.querySelector(`#scrollable-bar-chart-${this.id}`) != null;
                if (!containerElementExists) {
                    this.appElement.insertAdjacentHTML("beforeend", containerHtml);
                    this.containerElement = document.body.querySelector(`#scrollable-bar-chart-${this.id}`);
                }
                if (this.containerElement == null) {
                    throw new Error("Container element not found.");
                }
                const innerChartContainerHtml = `<div class="scrollable-bar-chart__chart-container chart-container" style="position: relative;"></div>`;
                const innerChartContainerElementExists = document.body.querySelector(`#scrollable-bar-chart-${this.id} .scrollable-bar-chart__chart-container`) != null;
                if (!innerChartContainerElementExists) {
                    this.containerElement.insertAdjacentHTML("beforeend", innerChartContainerHtml);
                    this.innerChartContainerElement = document.body.querySelector(`#scrollable-bar-chart-${this.id} .scrollable-bar-chart__chart-container`);
                }
                if (this.innerChartContainerElement == null) {
                    throw new Error("Inner chart container element not found.");
                }
                const innerChartHtml = `<div class="scrollable-bar-chart__chart" style="position: relative;"></div>`;
                const innerChartElementExists = document.body.querySelector(`#scrollable-bar-chart-${this.id} .scrollable-bar-chart__chart`) != null;
                if (!innerChartElementExists) {
                    this.innerChartContainerElement.insertAdjacentHTML("beforeend", innerChartHtml);
                    this.innerChartElement = document.body.querySelector(`#scrollable-bar-chart-${this.id} .scrollable-bar-chart__chart`);
                }
                if (this.innerChartElement == null) {
                    throw new Error("Inner chart element not found.");
                }
                this.setLegend();
            }
            setLegend() {
                try {
                    const legendElement = document.body.querySelector(`#scrollable-bar-chart-${this.id}-legend`);
                    if (legendElement == null) {
                        throw new Error("Legend element not found.");
                    }
                    let highlightedDatapoints;
                    // const statFieldsWithDifferentLegendWhenStacked = [
                    //   "Score",
                    //   "EncounterOpponentsScore",
                    // ];
                    if (this.statFieldsWithDifferentLegendWhenStacked.indexOf(this.statField) > -1 &&
                        this.shouldStack) {
                        const firstDatapoint = this.datapoints[0];
                        const firstLabel = this.statField == "Score"
                            ? CS.Helper.formatString(JSRess.ScoreOfX, firstDatapoint.Name)
                            : JSRess.RoundWins;
                        const secondLabel = this.statField == "Score"
                            ? JSRess.OpponentsScore
                            : JSRess.OpponentsRoundWins;
                        highlightedDatapoints = [
                            Object.assign(Object.assign({}, firstDatapoint), { Id: "statfield-1", barColor: this.barFillColor, Name: firstLabel, Value: "" }),
                            Object.assign(Object.assign({}, firstDatapoint), { Id: "statfield-2", barColor: this.stackedBarFillColor, Name: secondLabel, Value: "" }),
                        ];
                    }
                    else {
                        highlightedDatapoints = this.datapoints
                            .filter((d) => d.IsHighlightedMain)
                            .sort((a, b) => {
                            return Number(b.Value) - Number(a.Value);
                        });
                    }
                    if (!highlightedDatapoints.length) {
                        return;
                    }
                    highlightedDatapoints.forEach((datapoint) => {
                        var _a;
                        const rank = [...this.datapoints]
                            .sort((a, b) => {
                            return Number(b.Value) - Number(a.Value);
                        })
                            .indexOf(datapoint) + 1;
                        const opacity = datapoint.IsSpare ? 0.5 : 1;
                        const isHighlighted = datapoint.IsHighlightedMain || datapoint.IsHighlightedSecondary;
                        const color = datapoint.IsSpare && !isHighlighted
                            ? "rgba(255,255,255,0.35)"
                            : (_a = datapoint.barColor) !== null && _a !== void 0 ? _a : this.barFillColor;
                        const legendItemHtml = `
            <div class="scrollable-bar-chart__legend-item chart__legend-item" data-symbol="${datapoint.Id}">
              <div class="scrollable-bar-chart__legend-item__dot chart__legend-item__dot" style="background-color: ${color};"></div>
              <div class="scrollable-bar-chart__legend-item__label chart__legend-item__label" style="opacity: ${opacity};">${datapoint.Name}</div>
              <span>&nbsp;</span>
              <div class="scrollable-bar-chart__legend-item__value chart__legend-item__value">${datapoint.Value
                            ? this.valueFormatter(Number(datapoint.Value))
                            : ""}</div>
              ${this.shouldDisplayRank
                            ? `<span>&nbsp;</span>
                <div class="chart__legend-item__sub-value">(#${rank})</div>`
                            : ""}
            </div>`;
                        legendElement.insertAdjacentHTML("beforeend", legendItemHtml);
                    });
                }
                catch (error) {
                    console.error("Error while setting legend.", error);
                }
            }
            load() {
                return __awaiter(this, void 0, void 0, function* () {
                    this.numBars = this.datapoints.length;
                    if (this.useMinYValueForMin) {
                        const _min = d3.min(this.datapoints, (d) => Number(d.Value));
                        const minimumIsNegative = _min < 0;
                        this.min = _min - _min * 0.1;
                        if (!minimumIsNegative && this.min < 0) {
                            this.min = 0;
                        }
                    }
                    this.longestBottomXAxisLabelLength = d3.max(this.datapoints, (d) => this.shouldStack ? d.Name.length : d.XAxisBottomLabel.length);
                    this.firstBottomXAxisLabelLength = d3.sort(this.datapoints, (d) => {
                        if (this.sortDirection == CS.Enumeration.SortDirection.Descending) {
                            return -Number(d.SortValue);
                        }
                        return Number(d.SortValue);
                    })[0].XAxisBottomLabel.length;
                    yield this.setChartDimensions();
                });
            }
            initials(name) {
                if (!name)
                    return "";
                if (name.trim().length === 0)
                    return "";
                const names = name.split(" ");
                return names.map((name) => name.charAt(0).toUpperCase() + ".").join("");
            }
            render() {
                return new Promise((resolve, reject) => {
                    try {
                        if (this.shouldStack) {
                            this.series = d3
                                .stack()
                                // distinct series keys, in input order
                                .keys(d3.union(this.datapoints.map((d) => d.Id)))
                                // get value for each series key and stack
                                .value(([, D], key) => D.get(key).Value)(
                            // group by stack then series key
                            d3.index(this.datapoints, (d) => d.Key, (d) => d.Id));
                        }
                        // Determine the series that need to be stacked.
                        // Declare the x (horizontal position) scale.
                        if (this.shouldStack) {
                            this.xScale = d3
                                .scaleBand()
                                .domain(d3.groupSort(this.datapoints, (D) => d3.sum(D, (d) => {
                                if (this.sortDirection ==
                                    CS.Enumeration.SortDirection.Descending) {
                                    return -Number(d.SortValue);
                                }
                                return Number(d.SortValue);
                            }), (d) => d.Key.toString()))
                                //   .range([this.marginLeft, this.chartWidth - this.marginRight])
                                .rangeRound([
                                this.marginLeft,
                                this.marginLeft +
                                    this.barWidth * (this.numBars + 1 + this.barPadding),
                            ])
                                .padding(this.barPadding);
                        }
                        else {
                            this.xScale = d3
                                .scaleBand()
                                .domain(d3.groupSort(this.datapoints, ([d]) => {
                                if (this.sortDirection ==
                                    CS.Enumeration.SortDirection.Descending) {
                                    return -Number(d.SortValue);
                                }
                                return Number(d.SortValue);
                            }, (d) => d.Key.toString()))
                                //   .range([this.marginLeft, this.chartWidth - this.marginRight])
                                .rangeRound([
                                this.marginLeft,
                                this.marginLeft +
                                    this.barWidth * (this.numBars + 1 + this.barPadding),
                            ])
                                .padding(this.barPadding);
                        }
                        let extent;
                        if (this.shouldStack) {
                            const nonStackedDatapoints = this.datapoints.filter((d) => !d.IsStacked);
                            extent = d3.extent(nonStackedDatapoints, (d) => Number(d.Value) + Number(d.StackedValue));
                            // When stacked, and the extent[0] is not 0, the bars are not rendered correctly.
                            // Until this is fixed, we set the extent[0] to 0.
                            // Also, the extent[0] should sometimes be forced to 0 (e.g. when the Statfield is "Round Wins")
                            // since even a value of "1" should be rendered as a bar.
                            extent[0] = 0;
                        }
                        else {
                            extent = d3.extent(this.datapoints, (d) => Number(d.Value));
                        }
                        if (extent[0] == extent[1]) {
                            extent[0] = 0;
                        }
                        // Declare the y (vertical position) scale.
                        this.yScale = d3
                            .scaleLinear()
                            .domain(extent)
                            .range([this.chartHeight - this.marginBottom, this.marginTop])
                            .nice();
                        // Create the SVG container.
                        this.svg = d3
                            .create("svg")
                            .attr("width", this.chartWidth)
                            .attr("height", this.chartHeight +
                            (this.shouldStack && this.shouldDisplayAvatar
                                ? this.spacing
                                : 0))
                            .attr("viewBox", [0, 0, this.chartWidth, this.chartHeight]);
                        // Create the overlay SVG container.
                        if (!this.hideYAxis) {
                            this.svgOverlay = d3
                                .create("svg")
                                .attr("width", this.chartWidth)
                                .attr("height", this.chartHeight +
                                (this.shouldStack && this.shouldDisplayAvatar
                                    ? this.spacing
                                    : 0))
                                .attr("viewBox", [0, 0, this.chartWidth, this.chartHeight]);
                        }
                        // Add a rect for each bar.
                        if (this.shouldStack) {
                            this.svg
                                .append("g")
                                .selectAll()
                                .data(this.series)
                                .join("g")
                                .attr("fill", (d) => {
                                const firstDatapoint = d[0].data[1].get(d.key);
                                if (firstDatapoint.IsStacked) {
                                    return this.stackedBarFillColor;
                                }
                                else {
                                    return this.barFillColor;
                                }
                            })
                                .selectAll("rect")
                                .data((D) => D.map((d) => ((d.key = D.key), d)))
                                .join("rect")
                                .attr("class", "scrollable-bar-chart__bar hoverable trigger-datapoint-click-event chart__bar")
                                .attr("data-symbol", (d) => d.key)
                                .attr("fill-opacity", (d) => {
                                const firstDatapoint = d.data[1].get(d.key);
                                if (firstDatapoint.IsStacked) {
                                    return 0.5;
                                }
                                else {
                                    return 1;
                                }
                            })
                                .attr("data-datapoint", (d) => {
                                try {
                                    const datapoint = this.datapoints.find((datapoint) => datapoint.Key == d.data[0] && datapoint.Id == d.key);
                                    if (datapoint == null)
                                        return "";
                                    return JSON.stringify(datapoint);
                                }
                                catch (error) {
                                    return "";
                                }
                            })
                                .attr("x", (d) => this.xScale(d.data[0]))
                                .attr("y", (d) => this.yScale(d[1]))
                                .attr("height", (d) => this.yScale(d[0]) - this.yScale(d[1]))
                                .attr("width", this.xScale.bandwidth());
                        }
                        else {
                            this.svg
                                .append("g")
                                .selectAll()
                                .data(this.datapoints)
                                .join("rect")
                                .attr("fill", (d) => {
                                if (d.OverrideBarColor) {
                                    return d.OverrideBarColor;
                                }
                                return this.barFillColor;
                            })
                                .attr("fill-opacity", (d) => {
                                if (!this.anyHighlighted) {
                                    return this.barOpacity;
                                }
                                if (d.IsHighlightedMain) {
                                    return this.mainHighlightedBarOpacity;
                                }
                                if (d.IsHighlightedSecondary) {
                                    return this.secondaryHighlightedBarOpacity;
                                }
                                return this.nonHighlightedBarOpacity;
                            })
                                // add data-id attribute to each bar
                                .attr("data-id", (d) => d.Id)
                                .attr("x", (d) => this.xScale(d.Key.toString()))
                                // TODO: Support stacked bars animation.
                                .attr("y", this.yScale(this.yScale.domain()[0])) // Set to 0 to animate from bottom to top.
                                .attr("height", 0) // Set to 0 to animate from bottom to top.
                                .attr("class", "scrollable-bar-chart__bar hoverable trigger-datapoint-click-event chart__bar")
                                .attr("data-symbol", (d) => d.key)
                                .attr("data-datapoint", (d) => JSON.stringify(d))
                                .attr("width", this.xScale.bandwidth());
                        }
                        // Add the bottom x-axis and labels.
                        this.svg
                            .append("g")
                            .attr("transform", `translate(0,${this.chartHeight - this.marginBottom})`)
                            .call(d3
                            .axisBottom(this.xScale)
                            .tickSizeOuter(0)
                            .tickFormat((d) => {
                            return "";
                        }))
                            .selectAll("text")
                            .attr("transform", this.shouldStack && this.statField != "Score"
                            ? "translate(-15,0)rotate(-45)"
                            : "translate(-10,5)rotate(-45)")
                            .attr("class", "scrollable-bar-chart__bottom-x-axis-label chart__tick-label")
                            .attr("data-symbol", (d) => d)
                            .style("text-anchor", "end")
                            .attr("font-family", (d) => this.fontFamily)
                            .attr("font-weight", (d) => {
                            const datapoint = this.datapoints.find((datapoint) => datapoint.Key === d);
                            if (!datapoint)
                                return "bold";
                            if (datapoint.IsSpare) {
                                return "300";
                            }
                            return "bold";
                        })
                            // set max-width to prevent text from overflowing the chart.
                            .style("max-width", `${this.barWidth}px`)
                            .style("font-size", this.bottomXAxisFontSize)
                            .attr("fill", (d) => {
                            if (!this.shouldNotHighlight) {
                                if (!this.anyHighlighted) {
                                    return "rgba(255,255,255,0.87)";
                                }
                                const datapoint = this.datapoints.find((datapoint) => datapoint.Key === d);
                                if (!datapoint) {
                                    return "rgba(255,255,255,0.87)";
                                }
                                if (datapoint.IsHighlightedMain ||
                                    datapoint.IsHighlightedSecondary) {
                                    return this.highlightedBarTextColor;
                                }
                            }
                            return "rgba(255,255,255,0.87)";
                        })
                            .style("text-shadow", "rgba(0,0,0,0.75) 1px 1px 3px, rgba(0,0,0,0.75) 1px 1px 3px")
                            .style("opacity", (d) => {
                            if (this.shouldNotHighlight) {
                                return 1;
                            }
                            if (!this.anyHighlighted) {
                                return 1;
                            }
                            const datapoint = this.datapoints.find((datapoint) => datapoint.Key === d);
                            if (!datapoint) {
                                return 1;
                            }
                            if (datapoint.IsHighlightedMain) {
                                return 1;
                            }
                            if (datapoint.IsHighlightedSecondary) {
                                return 0.87;
                            }
                            return 0.6;
                        })
                            .append("tspan")
                            .attr("x", 0)
                            .attr("y", 0)
                            .attr("dy", "1.2em")
                            .text((d) => {
                            const datapoint = this.datapoints.find((datapoint) => datapoint.Key === d);
                            if (datapoint == null)
                                return "";
                            if (this.shouldStack && this.statField != "Score") {
                                if (CS.Helper.isNullOrWhiteSpace(datapoint.Name))
                                    return "";
                                const name = `VS - ${datapoint.Name}`;
                                if (name.length > this.maxBottomXAxisLabelLength) {
                                    return `${name.substring(0, this.maxBottomXAxisLabelLength - 3)}...`;
                                }
                                return name;
                            }
                            else {
                                if (CS.Helper.isNullOrWhiteSpace(datapoint.XAxisBottomLabel))
                                    return "";
                                if (datapoint.XAxisBottomLabel.length >
                                    this.maxBottomXAxisLabelLength) {
                                    return `${datapoint.XAxisBottomLabel.substring(0, this.maxBottomXAxisLabelLength - 3)}...`;
                                }
                                return datapoint.XAxisBottomLabel;
                            }
                        })
                            .append("tspan")
                            .attr("x", 0)
                            .attr("y", "1.2em")
                            .attr("dy", "1.2em")
                            .attr("font-weight", "300")
                            // .attr("opacity", "0.8")
                            .text((d) => {
                            if (!this.shouldStack ||
                                (this.shouldStack && this.statField == "Score")) {
                                return "";
                            }
                            const datapoint = this.datapoints.find((datapoint) => datapoint.Key === d);
                            if (datapoint == null)
                                return "";
                            if (CS.Helper.isNullOrWhiteSpace(datapoint.XAxisBottomLabel))
                                return "";
                            if (datapoint.XAxisBottomLabel.length >
                                this.maxBottomXAxisLabelLength) {
                                return `${datapoint.XAxisBottomLabel.substring(0, this.maxBottomXAxisLabelLength - 3)}...`;
                            }
                            return datapoint.XAxisBottomLabel;
                        });
                        const axisTop1 = d3.axisTop(this.xScale).tickFormat((d) => {
                            const datapoint = this.datapoints.find((datapoint) => datapoint.Key === d);
                            if (CS.Helper.isNullOrWhiteSpace(datapoint === null || datapoint === void 0 ? void 0 : datapoint.XAxisTopLabel))
                                return "";
                            return `${datapoint.XAxisTopLabel}`;
                        });
                        const axisTop2 = d3.axisTop(this.xScale).tickFormat((d) => {
                            const datapoint = this.datapoints.find((datapoint) => datapoint.Key === d);
                            const rank = this.datapoints.indexOf(datapoint) + 1;
                            return `#${rank}`;
                        });
                        if (this.shouldDisplayRank) {
                            this.svg
                                .append("g")
                                .attr("transform", `translate(0,${this.marginTop})`)
                                .call(axisTop2)
                                .call((g) => g.select(".domain").remove())
                                .call((g) => g.selectAll(".tick line").remove())
                                .selectAll("text")
                                .attr("class", "scrollable-bar-chart__top-x-axis-label chart__bar-label")
                                .attr("data-symbol", (d) => d)
                                .attr("fill", (d) => {
                                const datapoint = this.datapoints.find((datapoint) => datapoint.Key === d);
                                const rank = this.getRank(datapoint);
                                if (rank == 1) {
                                    return this.firstRankBarTextColor;
                                }
                                else if (rank == 2) {
                                    return this.secondRankBarTextColor;
                                }
                                else if (rank == 3) {
                                    return this.thirdRankBarTextColor;
                                }
                                return this.rankBarTextColor;
                            })
                                .attr("transform", (d) => {
                                if (d == null)
                                    return "";
                                const datapoint = this.datapoints.find((datapoint) => datapoint.Key === d);
                                if (datapoint == null)
                                    return "";
                                const y = this.yScale(Number(datapoint.Value)) - this.marginTop;
                                const adjustedY = y - this.imageWidth - this.spacing * 1.5;
                                return `translate(0, ${adjustedY})`;
                            })
                                .style("opacity", 0)
                                .style("font-weight", (d) => {
                                const datapoint = this.datapoints.find((datapoint) => datapoint.Key === d);
                                const rank = this.getRank(datapoint);
                                if (rank == 1) {
                                    return "bold";
                                }
                                else if (rank == 2) {
                                    return "bold";
                                }
                                else if (rank == 3) {
                                    return "bold";
                                }
                                return 300;
                            })
                                .style("text-anchor", "middle")
                                .attr("font-family", this.fontFamily)
                                .style("font-size", this.topXAxisFontSize)
                                .style("filter", "drop-shadow(0px 0px 1px black)");
                        }
                        // Add the top x-axis and labels/avatars.
                        this.svg
                            .append("g")
                            .attr("transform", `translate(0,${this.marginTop})`)
                            .call(axisTop1)
                            .call((g) => g.select(".domain").remove())
                            .call((g) => g.selectAll(".tick line").remove())
                            // Add avatars.
                            .call((g) => {
                            g.append("g")
                                .attr("class", "bar-avatars")
                                .style("opacity", 0)
                                .selectAll()
                                .data(this.datapoints.filter((d) => !d.IsStacked))
                                .join("svg:image")
                                .attr("class", "scrollable-bar-chart__top-x-axis-avatar chart__avatar hoverable trigger-datapoint-click-event")
                                .attr("data-datapoint", (d) => JSON.stringify(d))
                                .attr("data-symbol", (d) => d.Key)
                                .attr("x", (d) => {
                                const x = this.xScale(d.Key.toString());
                                return x + 1;
                            })
                                .attr("y", (d) => {
                                return (this.yScale(Number(d.Value) + Number(d.StackedValue)) -
                                    this.marginTop -
                                    this.xScale.bandwidth() -
                                    this.topXAxisFontSize * 2);
                            })
                                .attr("width", this.xScale.bandwidth() - 2)
                                .attr("height", this.xScale.bandwidth() - 2)
                                .attr("xlink:href", (d) => d.Avatar)
                                .attr("data-fallback-href", (d) => {
                                var _a;
                                return (_a = d.DefaultImageUrl) !== null && _a !== void 0 ? _a : "";
                            })
                                .attr("preserveAspectRatio", "xMidYMid slice")
                                .attr("clip-path", "circle(50%)");
                        })
                            // Add rect over each avatar
                            .call((g) => {
                            if (!this.shouldNotHighlight) {
                                g.append("g")
                                    .selectAll()
                                    .data(this.datapoints.filter((d) => !d.IsStacked))
                                    .join("rect")
                                    .attr("class", "avatar-rect chart__avatar-rect")
                                    .attr("data-symbol", (d) => d.Key)
                                    .attr("width", this.xScale.bandwidth() + 2)
                                    .attr("height", this.xScale.bandwidth() + 2)
                                    .attr("rx", this.xScale.bandwidth())
                                    .attr("ry", this.xScale.bandwidth())
                                    .attr("fill", "none")
                                    .attr("stroke", (d) => {
                                    if (d.IsHighlightedMain) {
                                        return this.barFillColor;
                                    }
                                    return "none";
                                })
                                    .attr("stroke-width", 4)
                                    .attr("x", (d) => {
                                    const x = this.xScale(d.Key.toString());
                                    return x + 1 - 2;
                                })
                                    .attr("y", (d) => {
                                    return (this.yScale(Number(d.Value) + Number(d.StackedValue)) -
                                        this.marginTop -
                                        this.xScale.bandwidth() -
                                        this.topXAxisFontSize * 2 -
                                        2);
                                });
                            }
                        })
                            .selectAll("text")
                            .attr("class", "scrollable-bar-chart__top-x-axis-label chart__bar-label")
                            .attr("data-symbol", (d) => d)
                            .attr("fill", (d) => {
                            const datapoint = this.datapoints.find((datapoint) => datapoint.Key === d);
                            if (datapoint === null || datapoint === void 0 ? void 0 : datapoint.OverrideBarTextColor) {
                                return datapoint.OverrideBarTextColor;
                            }
                            if (this.shouldStack)
                                return this.barTextColorIfStacked;
                            return this.barTextColor;
                        })
                            .attr("transform", (d) => {
                            if (d == null)
                                return "";
                            const datapoint = this.datapoints.find((datapoint) => datapoint.Key === d);
                            if (datapoint == null)
                                return "";
                            const y = this.yScale(Number(datapoint.Value)) - this.marginTop;
                            return `translate(0, ${y})`;
                        })
                            .style("opacity", 0)
                            .style("font-weight", (d) => {
                            if (this.shouldStack)
                                return "900";
                            return "bold";
                        })
                            .style("text-anchor", "middle")
                            .attr("font-family", this.fontFamily)
                            .style("font-size", this.topXAxisFontSize)
                            .style("filter", "drop-shadow(0px 0px 1px black)");
                        this.svg
                            .append("g")
                            .attr("transform", `translate(0,${this.marginTop})`)
                            // Add stacked labels.
                            .call(d3.axisTop(this.xScale).tickFormat((d) => {
                            const datapoint = this.datapoints.find((datapoint) => datapoint.Key === d);
                            const stackedDatapoint = datapoint == null
                                ? null
                                : this.datapoints.find((stackedDatapoint) => stackedDatapoint.Key === datapoint.Key &&
                                    stackedDatapoint.Id === `${datapoint.Id}-stacked`);
                            try {
                                if (CS.Helper.isNullOrWhiteSpace(datapoint === null || datapoint === void 0 ? void 0 : datapoint.XAxisTopLabel))
                                    return "";
                                if (stackedDatapoint == null)
                                    return "";
                                // If the stacked value is 0, don't show the label as it would overlap with the non-stacked label.
                                if (Number(stackedDatapoint.Value) == 0)
                                    return "";
                            }
                            catch (error) {
                                return "";
                            }
                            return `${stackedDatapoint.XAxisTopLabel}`;
                        }))
                            .call((g) => g.select(".domain").remove())
                            .call((g) => g.selectAll(".tick line").remove())
                            .selectAll("text")
                            .attr("class", "scrollable-bar-chart__top-x-axis-label-stacked")
                            .attr("fill", (d) => {
                            if (this.shouldStack)
                                return this.stackedBarTextColorIfStacked;
                            return this.barTextColor;
                        })
                            .attr("transform", (d) => {
                            if (d == null)
                                return "";
                            const datapoint = this.datapoints.find((datapoint) => datapoint.Key === d);
                            if (datapoint == null)
                                return "";
                            const y = this.yScale(Number(datapoint.Value) + Number(datapoint.StackedValue)) - this.marginTop;
                            return `translate(0, ${y})`;
                        })
                            .style("opacity", 0)
                            .style("font-weight", (d) => {
                            if (this.shouldStack)
                                return "900";
                            return "bold";
                        })
                            .style("text-anchor", "middle")
                            .attr("font-family", this.fontFamily)
                            .style("font-size", this.topXAxisFontSize)
                            .style("filter", 
                        // "drop-shadow(0px 1px 1px black) drop-shadow(0px -1px 1px black)"
                        "drop-shadow(0px 0px 1px black)");
                        // Add the y-axis and label, and remove the domain line.
                        this.svg
                            .append("g")
                            .style("opacity", 0) // A fixed y-axis is added on top of the chart, so we hide this one.
                            .attr("transform", `translate(${this.marginLeft},0)`)
                            .call(d3
                            .axisLeft(this.yScale)
                            .tickFormat((y) => this.isPercentage ? `${y}%` : y))
                            .call((g) => g.select(".domain").remove());
                        if (!this.hideYAxis) {
                            this.svgOverlay
                                .style("position", "absolute")
                                .style("top", "0")
                                .style("left", "0")
                                .style("pointer-events", "none")
                                .style("z-index", "1")
                                // .style("padding", this.spacing * 2)
                                .append("g")
                                .attr("class", "scrollable-bar-chart__svg-overlay-y-axis")
                                .style("opacity", 0.5)
                                .attr("transform", `translate(0,${this.chartHeight - this.marginBottom})`)
                                .attr("transform", `translate(${this.marginLeft},0)`)
                                .call(d3
                                .axisLeft(this.yScale)
                                .tickFormat((y) => this.isPercentage ? `${y}%` : y))
                                //.call(g => g.selectAll(".tick line").clone()
                                //    .attr("x2", this.chartWidth - this.marginLeft - this.marginRight)
                                //    .attr("stroke-opacity", 0.1))
                                .call((g) => g
                                .selectAll(".tick")
                                .attr("class", "scrollable-bar-chart__y-axis-label")
                                .attr("font-size", this.yAxisFontSize))
                                // .call((g: any) => g.select(".domain").remove())
                                // .call((g: any) => g.selectAll(".tick line").remove())
                                .call((g) => g
                                .selectAll(".tick text")
                                .attr("font-weight", "bold")
                                .attr("font-family", this.fontFamily)
                                //.attr("font-size", this.textFontSize * 2)
                                .attr("fill", this.barTextColor)
                            // add black background around the text
                            );
                            //.call(g => g.selectAll(".tick line").clone()
                            //    .attr("x2", this.chartWidth - this.marginLeft - this.marginRight)
                            //    .attr("stroke-opacity", 0.5))
                        }
                        // Domain line should be 0.5 oapcity
                        this.svg.selectAll(".tick line").style("opacity", 0.5);
                        this.svg.selectAll(".domain").style("opacity", 0.5);
                        setTimeout(() => {
                            if (this.svg == null)
                                return resolve();
                            // Animate the bars.
                            if (this.shouldStack) {
                            }
                            else {
                                this.svg
                                    .selectAll("rect:not(.avatar-rect)")
                                    .transition()
                                    .duration(500)
                                    .attr("y", (d) => this.yScale(d.Value))
                                    .attr("height", (d) => {
                                    const height = this.yScale(this.yScale.domain()[0]) -
                                        this.yScale(d.Value);
                                    if (height < 0)
                                        return 0;
                                    return height;
                                })
                                    .delay((d, i) => {
                                    return i * 2;
                                })
                                    .on("end", () => {
                                    return resolve();
                                });
                            }
                            // Animate the top x-axis avatars.
                            setTimeout(() => {
                                this.svg
                                    .selectAll(".bar-avatars")
                                    .transition()
                                    .duration(this.numBars * 2)
                                    .style("opacity", this.shouldStack && this.statField == "Score" ? 0 : 1);
                            }, this.numBars);
                            // Animate the top x-axis labels.
                            setTimeout(() => {
                                this.svg
                                    .selectAll(".scrollable-bar-chart__top-x-axis-label")
                                    .transition()
                                    .duration(this.numBars * 2)
                                    .style("opacity", 1);
                            }, this.numBars);
                            setTimeout(() => {
                                this.svg
                                    .selectAll(".scrollable-bar-chart__top-x-axis-label-stacked")
                                    .transition()
                                    .duration(this.numBars * 2)
                                    .style("opacity", 1);
                            }, this.numBars);
                            if (this.shouldStack) {
                                setTimeout(() => {
                                    return resolve();
                                }, this.numBars + 10);
                            }
                        }, 250);
                        const svgNode = this.svg.node();
                        if (!this.hideYAxis) {
                            const svgOverlayNode = this.svgOverlay.node();
                            if (!svgOverlayNode) {
                                return reject(new Error("SVG node not found."));
                            }
                            this.innerChartContainerElement.appendChild(svgOverlayNode);
                        }
                        if (!svgNode) {
                            return reject(new Error("SVG node not found."));
                        }
                        if (!this.innerChartElement) {
                            return reject(new Error("Chart element not found."));
                        }
                        if (!this.innerChartContainerElement) {
                            return reject(new Error("Chart container element not found."));
                        }
                        this.innerChartElement.appendChild(svgNode);
                        this.innerChartContainerElement.style.maxHeight = `${this.chartHeight + 100 // In case the scroll bar is visible.
                        }px`;
                        this.setOverlay();
                    }
                    catch (error) {
                        return reject(error);
                    }
                });
            }
            rankDatapoints() {
                var _a, _b;
                try {
                    if (!((_b = (_a = this.datapoints) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0)) {
                        return;
                    }
                    const sortedDatapoints = this.datapoints.sort((a, b) => {
                        if (this.sortDirection == CS.Enumeration.SortDirection.Descending) {
                            return Number(b.SortValue) - Number(a.SortValue);
                        }
                        return Number(a.SortValue) - Number(b.SortValue);
                    });
                    this.rankByKey = new Map();
                    let rank = 1;
                    let previousValue = Number(sortedDatapoints[0].SortValue);
                    for (let i = 0; i < sortedDatapoints.length; i++) {
                        const datapoint = sortedDatapoints[i];
                        const value = Number(datapoint.SortValue);
                        if (value !== previousValue) {
                            rank++;
                        }
                        this.rankByKey.set(datapoint.Key, rank);
                        previousValue = value;
                    }
                }
                catch (error) {
                    console.error("Error while ranking datapoints.", error);
                }
            }
            getRank(datapoint) {
                try {
                    if (!this.rankByKey) {
                        return NaN;
                    }
                    const rank = this.rankByKey.get(datapoint.Key);
                    if (rank == null) {
                        return NaN;
                    }
                    return rank;
                }
                catch (error) {
                    console.error("Error while getting rank.", error);
                    return NaN;
                }
            }
            handleInitButtonClick() {
                if (this.state !== CS.Enumeration.ChartState.Unready) {
                    this.destroy();
                }
                this.init();
            }
            handleDestroyButtonClick() {
                this.destroy();
            }
            bindEvents() {
                var _a, _b;
                if (this.eventsBound)
                    return;
                (_a = document.body
                    .querySelector(`#scrollable-bar-chart-${this.id}-btn-init`)) === null || _a === void 0 ? void 0 : _a.addEventListener("click", this.handleInitButtonClick.bind(this));
                (_b = document.body
                    .querySelector(`#scrollable-bar-chart-${this.id}-btn-destroy`)) === null || _b === void 0 ? void 0 : _b.addEventListener("click", this.handleDestroyButtonClick.bind(this));
                // Bind events on legend item
                $(this.containerElement).offon("click.legendItemClicked", ".chart__legend-item", this.handleLegendItemClick.bind(this));
                this.eventsBound = true;
            }
            handleLegendItemClick(event) {
                try {
                    const $clickedItem = $(event.currentTarget);
                    const clickedItemDataSymbol = $clickedItem.attr("data-symbol");
                    if (!clickedItemDataSymbol) {
                        throw new Error("Symbol not found.");
                    }
                    const clickedItemSymbol = Number(clickedItemDataSymbol);
                    if (isNaN(clickedItemSymbol)) {
                        throw new Error("Symbol is not a number.");
                    }
                    const onClass = "selected";
                    const offClass = "not-selected";
                    const $legend = $clickedItem.closest(".chart__legend");
                    const $items = $legend.find(".chart__legend-item");
                    const $bars = $(this.containerElement).find(".chart__bar");
                    const $avatars = $(this.containerElement).find(".chart__avatar");
                    const $barLabels = $(this.containerElement).find(".chart__bar-label");
                    const $tickLabels = $(this.containerElement).find(".chart__tick-label");
                    const $avatarRects = $(this.containerElement).find(".chart__avatar-rect");
                    const wasSelected = $clickedItem.hasClass(onClass);
                    $clickedItem.toggleClass(onClass, !wasSelected);
                    const anyItemSelected = $items
                        .toArray()
                        .some((item) => $(item).hasClass(onClass));
                    this.symbols.forEach((dataSymbol) => {
                        const $item = $legend.find(`[data-symbol="${dataSymbol}"]`);
                        const symbol = Number(dataSymbol);
                        if (isNaN(symbol)) {
                            return;
                        }
                        const isSelected = $item.hasClass(onClass);
                        const $bar = $bars.filter(`[data-id="${symbol}"]`);
                        const $avatar = $avatars.filter(`[data-symbol="${symbol}"]`);
                        const $barLabel = $barLabels.filter(`[data-symbol="${symbol}"]`);
                        const $tickLabel = $tickLabels.filter(`[data-symbol="${symbol}"]`);
                        const $avatarRect = $avatarRects.filter(`[data-symbol="${symbol}"]`);
                        if (!anyItemSelected) {
                            $item.removeClass(offClass);
                            $bar.removeClass(offClass);
                            $avatar.removeClass(offClass);
                            $barLabel.removeClass(offClass);
                            $tickLabel.removeClass(offClass);
                            $avatarRect.removeClass(offClass);
                        }
                        else {
                            if (isSelected) {
                                $item.removeClass(offClass);
                                $bar.removeClass(offClass);
                                $avatar.removeClass(offClass);
                                $barLabel.removeClass(offClass);
                                $tickLabel.removeClass(offClass);
                                $avatarRect.removeClass(offClass);
                            }
                            else {
                                $item.addClass(offClass);
                                $bar.addClass(offClass);
                                $avatar.addClass(offClass);
                                $barLabel.addClass(offClass);
                                $tickLabel.addClass(offClass);
                                $avatarRect.addClass(offClass);
                            }
                        }
                    });
                }
                catch (error) {
                    console.error("Error while handling legend item click.", error);
                }
            }
            // private unbindEvents() {
            //   document.body
            //     .querySelector(`#scrollable-bar-chart-${this.id}-btn-init`)
            //     ?.removeEventListener("click", this.handleInitButtonClick.bind(this));
            //   document.body
            //     .querySelector(`#scrollable-bar-chart-${this.id}-btn-destroy`)
            //     ?.removeEventListener("click", this.handleDestroyButtonClick.bind(this));
            // }
            setState(newState) {
                this.state = newState;
                this.updateUI();
            }
            updateUI() {
                switch (this.state) {
                    case CS.Enumeration.ChartState.Initializing:
                        // this.innerChartContainerElement?.style.setProperty("opacity", "0.5");
                        //this.initButtonElement?.setAttribute("disabled", "disabled");
                        //this.destroyButtonElement?.setAttribute("disabled", "disabled");
                        break;
                    case CS.Enumeration.ChartState.Unready:
                        // this.innerChartContainerElement?.style.setProperty("opacity", "0.5");
                        //this.initButtonElement?.removeAttribute("disabled");
                        //this.destroyButtonElement?.setAttribute("disabled", "disabled");
                        break;
                    case CS.Enumeration.ChartState.Ready:
                        // this.innerChartContainerElement?.style.setProperty("opacity", "1");
                        //this.initButtonElement?.setAttribute("disabled", "disabled");
                        //this.destroyButtonElement?.removeAttribute("disabled");
                        break;
                    case CS.Enumeration.ChartState.Destroying:
                        // this.innerChartContainerElement?.style.setProperty("opacity", "0.5");
                        //this.initButtonElement?.setAttribute("disabled", "disabled");
                        //this.destroyButtonElement?.setAttribute("disabled", "disabled");
                        break;
                    case CS.Enumeration.ChartState.Running:
                        break;
                    case CS.Enumeration.ChartState.Stopping:
                        break;
                    case CS.Enumeration.ChartState.Stopped:
                        break;
                    case CS.Enumeration.ChartState.Error:
                        break;
                    case CS.Enumeration.ChartState.Finished:
                        break;
                    default:
                        break;
                }
            }
            destroy() {
                return new Promise((resolve, reject) => {
                    var _a;
                    try {
                        this.setState(CS.Enumeration.ChartState.Destroying);
                        (_a = this.svgLegend) === null || _a === void 0 ? void 0 : _a.remove();
                        this.svg
                            .selectAll(".scrollable-bar-chart__top-x-axis-label")
                            .transition()
                            .duration(500)
                            .style("opacity", 0)
                            .remove();
                        this.svg
                            .selectAll(".bar-avatars")
                            .transition()
                            .duration(500)
                            .style("opacity", 0)
                            .remove();
                        this.svg
                            .selectAll("rect")
                            .transition()
                            .duration(500)
                            .attr("y", this.yScale(this.yScale.domain()[0]))
                            .attr("height", (d) => 0)
                            .delay((d, i) => {
                            return i * 2;
                        })
                            .on("end", () => {
                            if (this.innerChartContainerElement != null) {
                                this.innerChartContainerElement.style.maxHeight = "0";
                            }
                            setTimeout(() => {
                                d3.selectAll(`#scrollable-bar-chart-${this.id} svg > *`).remove();
                                this.svg = null;
                                this.svgOverlay = null;
                                if (this.innerChartContainerElement != null) {
                                    this.innerChartContainerElement.outerHTML = "";
                                    this.innerChartContainerElement = null;
                                }
                                // this.unbindEvents();
                                this.setState(CS.Enumeration.ChartState.Unready);
                                resolve();
                            }, 500);
                        });
                    }
                    catch (error) {
                        console.error(error);
                        this.setState(CS.Enumeration.ChartState.Error);
                        reject(error);
                    }
                });
            }
            setOverlay() {
                var _a, _b;
                try {
                    if (!this.innerChartContainerElement) {
                        throw new Error("Inner chart element not found.");
                    }
                    const overlayHTML = `<div class="scrollable-bar-chart__overlay"></div>`;
                    const overlayElementExists = document.body.querySelector(`#scrollable-bar-chart-${this.id} .scrollable-bar-chart__overlay`) != null;
                    if (!overlayElementExists) {
                        this.innerChartContainerElement.insertAdjacentHTML("beforeend", overlayHTML);
                        this.chartOverlayElement = document.body.querySelector(`#scrollable-bar-chart-${this.id} .scrollable-bar-chart__overlay`);
                    }
                    if (!this.chartOverlayElement || this.chartOverlayElement == null) {
                        throw new Error("Chart overlay element not found.");
                    }
                    this.chartOverlayElement.style.width = `${this.marginLeft}px`;
                    this.chartOverlayElement.style.height = `${this.chartHeight - this.marginBottom + this.yAxisFontSize / 2
                    // (this.shouldStack && this.shouldDisplayAvatar
                    //   ? this.yAxisFontSize * 1.5
                    //   : 0)
                    }px`;
                    this.chartOverlayElement.style.pointerEvents = "none";
                    let backgroundColor = "";
                    let parent = this.containerElement;
                    while (parent) {
                        let parentBackgroundColor = (_b = (_a = parent === null || parent === void 0 ? void 0 : parent.computedStyleMap().get("background-color")) === null || _a === void 0 ? void 0 : _a.toString()) !== null && _b !== void 0 ? _b : "";
                        const isTransparentColor = parentBackgroundColor.includes("rgba(0, 0, 0, 0)");
                        if (isTransparentColor) {
                            parentBackgroundColor = "";
                        }
                        if (parentBackgroundColor) {
                            backgroundColor = parentBackgroundColor;
                            break;
                        }
                        parent = parent.parentElement;
                    }
                    this.chartOverlayElement.style.backgroundColor = backgroundColor !== null && backgroundColor !== void 0 ? backgroundColor : "";
                }
                catch (error) {
                    console.error("Error while setting overlay width.", error);
                }
            }
            handleDatapointClick(datapoint) {
                try {
                    if (!datapoint)
                        return;
                    if (typeof datapoint !== "string")
                        return;
                    datapoint = JSON.parse(datapoint);
                    const { OpponentDetailsPopupUrl } = datapoint;
                    if (!OpponentDetailsPopupUrl ||
                        CS.Helper.isNullOrWhiteSpace(OpponentDetailsPopupUrl))
                        return;
                    Controls.Popup.ShowAjaxModal(OpponentDetailsPopupUrl, {}, (p) => { }, (p) => { }, true);
                }
                catch (error) {
                    console.error("Error handling datapoint click.", error);
                }
            }
        }
        Controls.ScrollableBarChart = ScrollableBarChart;
    })(Controls = CS.Controls || (CS.Controls = {}));
})(CS || (CS = {}));

//# sourceMappingURL=ScrollableBarChart.js.map
